// these userTypes are not referred anywhere else in the code

export default {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FREE_USER: 'FREE_USER',
  AFFILIATE_USER: 'AFFILIATE_USER',
  EXTERNAL_ADMIN_USER: 'EXTERNAL_ADMIN_USER',
  PAID_USER: 'PAID_USER'
};
